var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#1E4161"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_985_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9994 15.2027L15.2021 11M9.42342 12.576L7.84742 14.152C7.29012 14.7093 6.97702 15.4652 6.97702 16.2533C6.97702 17.0415 7.29012 17.7973 7.84742 18.3547C8.40473 18.912 9.1606 19.2251 9.94876 19.2251C10.7369 19.2251 11.4928 18.912 12.0501 18.3547L13.6261 16.7787M12.5754 9.424L14.1514 7.848C14.7087 7.2907 15.4646 6.9776 16.2527 6.9776C17.0409 6.9776 17.7968 7.2907 18.3541 7.848C18.9114 8.40531 19.2245 9.16118 19.2245 9.94933C19.2245 10.7375 18.9114 11.4934 18.3541 12.0507L16.7781 13.6267",
    stroke: "white",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_985_314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.47616c04ab651e2b339baf73ba0f531a.svg";
export { ForwardRef as ReactComponent };